import React from 'react';
import styled from 'react-emotion';
import { screenWidths } from '../utils/constants';
import { AboutPageContent } from '../components/About/AboutPage';
import { LightTitle, grid } from '../components/Common';

const AboutPageContainer = styled.div`
  background-color: white;
  padding: 10vh 0;
  height: 100vh;
  @media screen and (min-width: ${screenWidths.lg}px) {
    padding: 10vh 0;
  }
  ${LightTitle}:not(:first-child) {
    margin-top: 5.5rem;
  }
  ${grid.container}

  p.text {
    font-family: ZeitungMicroPro-Light;
    line-height: 2em;
    margin-bottom: 2em;
    text-align: justify;
  }

  p.bigger {
    font-family: ZeitungMicroPro-Light;
    font-size: 18px;
    margin: 0;
  }

  p.address {
    font-size: 14px;
  }

`;

const Content = styled.div`
  
  overflow: scroll;
  &::-webkit-scrollbar {
    width: 5px;
  }

  &::-webkit-scrollbar-thumb {
    background-color: #818578;
  }

  @media screen and (min-width: ${screenWidths.lg}px) {
    display: block;
  }

  grid-column: 1 / -1;
  padding: 0 5vw;
  height: 86vh;

  @media screen and (min-width: ${screenWidths.lg}px) {
    height: 80vh;
    grid-column: 3 / 11;
  }

  .imgNosotros{
    width: 100%;
    height: 300px;
    object-fit: cover;
  }

`;

export default ({ data }) => {
  return (
    <AboutPageContainer>
      <Content>
        <AboutPageContent aboutInfo={data.aboutInfo.edges[0].node} />
      </Content>
    </AboutPageContainer> 
  )
}

export const query = graphql`
  query AboutPageQuery {
    aboutInfo: allContentfulAboutInformation {
      edges {
        node {
          id
          pageTitle
          teamSectionTitle
          colaboradorTitle
          contactSectionTitle
          address
          contactEmail
          phoneNumber
          mainImage {
            file {
              url
            }
          }
          teamPhoto {
            file {
              url
            }
          }
          team {
            id
            fullName
            picture {
              file {
                url
              }
            }
            jobTitle
            description {
              description
            }
          }

          colaboradores{
            id
            colaboradorName
            fotoColaborador{
              file {
                url
              }
            }
            colaboradorJob
          }

          description {
            description
          }
          
        }
      }
    }
  }
`



// WEBPACK FOOTER //
// ./src/pages/about.js